import Image from 'next/image';
import styled from 'styled-components';

import { Tag } from './tag';

export const Card = styled.section`
  display: block;
  background-color: ${(props) => props.theme.noContrast};
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid ${(props) => props.theme.stroke};
  h2 {
    line-height: initial;
  }
`;

export const CardContent = styled.div`
  padding: 1rem;
`;

export const CardImageWrapper = styled.div`
  position: relative;
`;

const ContentItemImage = styled(Image)`
  object-fit: cover;
`;

export function CardImage({ src, tag }) {
  return (
    <CardImageWrapper>
      <Tag overImage>{tag}</Tag>
      <ContentItemImage src={src} layout="responsive" width={100} height={40} />
    </CardImageWrapper>
  );
}
